<div class="share-dir-dialog">
  <app-verify-email-required *ngIf="!isVerified" [cancelButtonText]="'Close'" (showDialogChange)="closeDialog()"
  [message]="'Your account must be verified in order to create a shared folder.'"></app-verify-email-required>

  <sync-dialog *ngIf="isVerified"
    [config]="{
      title: isNewFolder ? 'New share folder' : 'Share folder',
      isClosable: true,
      actionButton: (isVerified && !isShareLimit && !spinnerOnSubmit) && !loadingOnShareInfo ? isNewFolder ? 'Create':'Invite' : '',
      cancelButton: spinnerOnSubmit || loadingOnShareInfo ? '' : 'Cancel',
      onActionClick: makeShare,
      onCancelClick: cancelDialog,
      onCloseIcon: closeDialog,
      closeIcon: isNewFolder ? 'arrow-left' : 'close',
      isActionButtonDisabled: newShareFolderNameValid || errors.length > 0 || errorMessage.length > 0
    }"
    [open]="showDialog"
    [onClose]="closeDialog"
    [isFullScreen]="isSmallScreen"
  >
    <div class="invite-collaborators-dir-dialog-content">
      <ng-container *ngIf="spinnerOnSubmit || loadingOnShareInfo">
        <sync-spinner></sync-spinner>
        <p class="subtitle-1 text-center" *ngIf="spinnerOnSubmit">Creating shared folder...</p>
      </ng-container>

      <app-error *ngIf="errcode" [errcode]="errcode"></app-error>
      <div [class.hide]="spinnerOnSubmit || loadingOnShareInfo" *ngIf="errcode?.code !== 8027">
        <sync-text-field
          *ngIf="syncId"
          [label]="'Folder name'"
          [value]="filename"
          [readOnly]="true"
        ></sync-text-field>
        <sync-text-field
        *ngIf="!syncId"
         [label]="'Folder name'"
         [inputChange]="folderNameChange"
         [errorMessage]="errorMessage"
         [value]="filename"
        ></sync-text-field>
        <div class="member-invite-container">
          <span class="body-2">
            Users who accept your invitation will have this folder added to their
            Sync account and synchronized to their computers when the desktop
            application is installed.
            <a class="body-2-link" href="https://help.sync.com/hc/en-us/articles/38492019181459-How-to-use-team-shared-folders" target="_blank">Learn more.</a>
          </span>
        </div>
        <div class="email-container">
          <app-share-member-add
            [sharememberInvite]="sharememberInvite"
            (shareMemberInviteChange)="shareMemberInviteChange($event)"
            [closeDialog]="closeDialog"
          ></app-share-member-add>
        </div>
      </div>
    </div>
  </sync-dialog>
</div>
